import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField'
import React from 'react'

const FormCurrencyField = ({ id, text, fkProps, number, password, disabled, ...rest }) => {
  const denseStyle = {
    margin: "dense",
    variant: "filled",
    size: 'small',
    style: {
      background: '#c4c4c4',
      fontWeight: 'bold',
      ...rest.style
    }
  }

  return (
    <CurrencyTextField
      {...rest}
      currencySymbol="R$"
      outputFormat="number"
      decimalCharacter=","
      digitGroupSeparator="."
      type={null}
      id={id}
      label={text}
      helperText={fkProps.touched[id] ? fkProps.errors[id] : ""}
      error={fkProps.touched[id] && Boolean(fkProps.errors[id])}
      value={fkProps.values[id]}
      onChange={(e, v) => fkProps.setFieldValue(id, v)}
      onBlur={fkProps.handleBlur}
      disabled={disabled}

      {...denseStyle}
    />
  )
}

export default FormCurrencyField